/* Domovoi · key-value storage, behind one door.

   localStorage, everywhere. In the app the session is also kept in Capacitor
   Preferences (D2.4): iOS can clear a WebView's storage under pressure, and
   Preferences survives it; core/native.js puts it back at launch. The plugin is
   reached through window.Capacitor, never imported, and an app without it
   (before the store build that carries it) just skips this. Every read and
   write is wrapped: storage can be full, blocked or missing. */
import { AUTH_STORAGE_KEY } from './config.js';

function prefs() {
  var C = typeof window !== 'undefined' && window.Capacitor;
  try {
    return C && C.isNativePlatform && C.isNativePlatform() && C.isPluginAvailable && C.isPluginAvailable('Preferences') ? C.Plugins.Preferences : null;
  } catch (e) { return null; }
}
function keep(k, v) {
  if (k !== AUTH_STORAGE_KEY) return;
  var P = prefs();
  if (!P) return;
  try { (v == null ? P.remove({ key: k }) : P.set({ key: k, value: v })).catch(function () {}); } catch (e) {}
}

var backend = {
  get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  remove: function (k) { try { localStorage.removeItem(k); } catch (e) {} },
};

export var storage = {
  get: function (k) { return backend.get(k); },
  set: function (k, v) { backend.set(k, v); keep(k, v); },
  remove: function (k) { backend.remove(k); keep(k, null); },
};

/* The copy kept in the app's Preferences, for core/native.js (null on the web). */
export function keptSession() { return prefs(); }

export function useStorageBackend(next) { backend = next; }
